<div class="modal modal-xl">
    <div class="modal-header">
        <div class="modal-title">{{ title | fromLocaleStringMap }}</div>
        <button class="modal-close" (click)="close()">
            <app-icon [key]="'clear'" />
        </button>
    </div>
    @if (surveyModel) {
        <div class="modal-content">
            <app-survey [survey]="surveyModel" />
        </div>
    }
</div>
